const styles = theme => ({
  batteryAgreement: {
    fontSize: theme.typography.body1.fontSize,
    "& ul": {
      fontSize: "inherit",
      "& li": {
        fontSize: "inherit",
      }
    }
  },
  warning: {
    color: theme.palette.fail,
  },
});

export default styles;
